import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=9e851968&scoped=true&"
import script from "./goodDetail.vue?vue&type=script&lang=js&"
export * from "./goodDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=9e851968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e851968",
  null
  
)

export default component.exports